import { Request, RequestStatus } from '.';
import { IUser } from '../common';
import { Request as LegacyReq } from '../legacy';
import { LegacyStatus } from '../legacyStatus';
import { Request as HelpDeskRequest } from '../help-desk';

export const diPanels = ({
  user,
  disableOperationsHelpDsk,
}: {
  user: IUser;
  disableOperationsHelpDsk: boolean;
}) => [
  {
    value: 0,
    panel: () => <Request user={user} key="Revocations" diTab={true} />,
  },
  {
    value: 1,
    panel: () => (
      <RequestStatus
        di={true}
        requestorEmail={user.loginEmail}
        disableOperationsHelpDsk={disableOperationsHelpDsk}
        legacy={false}
      />
    ),
  },
  {
    value: 2,
    panel: () => <LegacyReq user={user} />,
  },
  {
    value: 3,
    panel: () => (
      <LegacyStatus
      />
    ),
  },
  {
    value: 4,
    panel: () => (
      <HelpDeskRequest
        user={user}
        key="Search Users"
        searchUsers
        forRegistrantsNCoordinators={false}
        // diTab={true}
      />
    ),
  },
];
